import { forwardRef } from 'react';
import './styles/components/_1_tg-float-button.scss';
import logoSrc from './assets/tg_logo.svg';

const TelegramFloatButton = forwardRef(function TelegramFloatButton(
  {
    href = "https://t.me/energo_business",
    liftOffset = 0,
  },
  ref
) {
  return (
    <a
      ref={ref}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="tg-float-btn"
      style={{ "--tg-lift": `${liftOffset}px` }}
      aria-label="Telegram"
    >
      <img src={logoSrc} alt="" aria-hidden="true" />
    </a>
  );
});

export default TelegramFloatButton;
